import { useState } from 'react'
import { Banner, Button, Card } from '../components.jsx'
import PageHeader from './PageHeader.jsx'

/**
 * API documentation, inside the console.
 *
 * **Embedded, not reimplemented — and that distinction is the whole point.** Swagger UI is generated from the
 * running backend's OpenAPI document: every endpoint, parameter and schema comes from the code that serves it.
 * Rebuilding that as React pages would mean maintaining a hand-written copy of something that regenerates
 * itself, and the copy would be wrong the first time an endpoint changed — the "documentation cites an endpoint
 * rather than a screen" failure CLAUDE.md rule 24 was written about, inverted.
 *
 * So it is framed here rather than linked away. The user stays in the console with one sign-in and one
 * navigation, which was the complaint, while the content stays generated, which is the property worth keeping.
 *
 * The frame is same-origin (`/swagger-ui/index.html` off this host), so no CORS and no mixed content. A
 * "Open in a new tab" escape is offered too: Swagger's own layout wants width, and on a narrow window a
 * full tab is genuinely better than a frame.
 */
export default function ApiDocs() {
  const [failed, setFailed] = useState(false)

  return (
    <>
      <PageHeader
        title="API documentation"
        subtitle="Generated from the running backend — every endpoint, parameter and schema"
        actions={
          <a className="btn" href="/swagger-ui/index.html" target="_blank" rel="noreferrer">
            Open in a new tab
          </a>
        }
      />

      <Banner kind="info">
        This is the live OpenAPI browser, generated by the backend rather than written by hand — so it cannot
        drift from what the server actually accepts. Requests you send from here use their own authorisation,
        not this console&apos;s session.
      </Banner>

      {failed ? (
        <Card title="Could not embed the documentation">
          <p className="muted">
            The browser refused to frame Swagger UI. It is still reachable directly.
          </p>
          <Button onClick={() => window.open('/swagger-ui/index.html', '_blank')}>Open API documentation</Button>
        </Card>
      ) : (
        <Card>
          {/*
            A tall frame rather than a fitted one: Swagger UI manages its own scrolling and an outer container
            that scrolled as well would trap the inner one — the reader ends up fighting two scrollbars. 78vh
            leaves the console's own navigation visible, which is the reason for embedding it at all.
          */}
          <iframe
            title="API documentation"
            src="/swagger-ui/index.html"
            onError={() => setFailed(true)}
            style={{
              width: '100%',
              height: '78vh',
              border: '1px solid var(--outline-variant)',
              borderRadius: 'var(--radius-sm)',
              background: 'var(--surface)',
            }}
          />
        </Card>
      )}
    </>
  )
}
